import React from "react";

import { BlankLink } from "../Shared";
import { ReactComponent as FacebookIcon } from "./icon-facebook.svg";
import { ReactComponent as InstagramIcon } from "./icon-instagram.svg";
import { ReactComponent as TwitterIcon } from "./icon-twitter.svg";

import FooterWrap from "./FooterWrap";
import Section, { IconGroup } from "./FooterSection";

const Footer = () => (
  <FooterWrap>
    <Section header="&copy; Harry's, Inc. All Rights Reserved.">
      <p>
        Harry's, H', Mammoth Design, Give a Shave, and Truman are all trademarks
        and/or registered trademarks of Harry's, Inc.
      </p>
      <p>
        <BlankLink
          href="https://www.harrys.com/privacy-policy"
          children="Privacy Policy"
        />

        <BlankLink
          href="https://www.harrys.com/terms-of-service"
          children="Terms of Service"
        />
      </p>
    </Section>

    <Section header="Contact">
      <ul>
        <li>
          <BlankLink
            href="mailto:ukhelp@harrys.com"
            children="ukhelp@harrys.com"
          />
        </li>
        <li>
          <BlankLink href="tel:+4408081648618" children="+44 0808 164 8618" />
        </li>
      </ul>
    </Section>

    <Section header="Connect">
      <IconGroup>
        <BlankLink href="https://www.facebook.com/hapostrophe">
          <FacebookIcon alt="facebook icon" />
        </BlankLink>

        <BlankLink href="https://www.instagram.com/harrys/">
          <InstagramIcon alt="instagram icon" />
        </BlankLink>

        <BlankLink href="https://twitter.com/harrys">
          <TwitterIcon alt="twitter icon" />
        </BlankLink>
      </IconGroup>
    </Section>
  </FooterWrap>
);

export default Footer;
